module.exports = __webpack_public_path__ + "img/the-cybernetic-tea-shop.b16408f4.png";